import React, { useEffect } from 'react';
import Header from "./Header";
import { Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const Home = ({ setHeaderTitle }) => {


  return (
    <div>
      
    </div>
  );
};

export default Home;